const ROLES_ES = {
  admin: "Administrador",
  companion: "Acompañante",
  comptable: "Contable",
  gestionnaire: "Gestor",
  manager: "Gerente",
  membre: "Miembro",
  operative: "Operativo",
} as const;

export default ROLES_ES;
